import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { delay } from 'rxjs/operators';
import moment from 'moment';

import { BaseUI } from '../../base.ui';
import { Client } from '../../../domain/data';
import { CountryInterface, DocumentType, GetCountriesUseCase, GetLegalDisclaimerUseCase } from '../../../../core';
import { ErrorDialog } from '../../dialog/error/error.dialog';
import { LegalDialog } from '../../dialog/legal/legal.dialog';
import { ParentEvents } from '../../../utils/parent-events.service';

import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'thr-contract-form-participant-legal-person',
    templateUrl: './contract-form-participant-legal-person.component.html',
    styleUrls: ['./contract-form-participant-legal-person.component.scss'],
})
export class ContractFormParticipantLegalPersonComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public DocumentType: typeof DocumentType = DocumentType;

    public countries: CountryInterface[];
    public isClientPortal = environment.portalClient;
    public today = moment();

    @Input()
    client: Client;

    @Input()
    currentAttorneyInFact: Client;

    constructor(
        parentEvents: ParentEvents,
        private dialog: MatDialog,
        private getCountriesUseCase: GetCountriesUseCase,
        private getLegalDisclaimerUseCase: GetLegalDisclaimerUseCase
    ) {
        super(parentEvents);
    }

    ngOnInit() {
        this.getCountries();
    }

    private getCountries() {
        this.getCountriesUseCase
            .bind()
            .pipe(delay(1)) // prevent ExpressionChangedAfterItHasBeenCheckedError
            .subscribe((transaction) => {
                if (transaction.isSuccess) {
                    this.countries = transaction.data;
                } else if (!transaction.isAuthError) {
                    this.dialog.open(ErrorDialog);
                }
            });
    }

    onExonerate() {
        this.parentEvents.resize();
    }

    openDialog() {
        this.getLegalDisclaimerUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.dialog.open(LegalDialog, {
                    data: {
                        text: transaction.data,
                        title: 'dialog.info-rgpd-title',
                        ok: 'general.close',
                    },
                });
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }
}
